import { render, staticRenderFns } from "./AttachmentsView.vue?vue&type=template&id=307c38d7&scoped=true"
import script from "./AttachmentsView.vue?vue&type=script&lang=js"
export * from "./AttachmentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c38d7",
  null
  
)

export default component.exports